<template>
  <div class="item"
    :class="{
      hasIcon: hasIcon,
      disabledMobile: item.data.disabledMobile,
      disabledTablet: item.data.disabledTablet,
      isActive: item.isRoot && isActive,
      isSubActive: !item.isRoot && isActive
    }">
    <div class="inner">
      <div v-if="item.isRoot && isActive" class="activeAcc top" :style="{background: activeAcc('top')}"></div>
      <img v-if="typeof (item.data.icon) !== 'undefined' && item.data.icon !== ''" :src="item.data.icon" class="icon" alt="" />
      <img v-if="typeof (item.data.icon2) !== 'undefined' && item.data.icon2 !== ''" :src="item.data.icon2" class="icon icon2" alt="" />
      <SetLink
        :linkTarget="item.data"
        :linkText="item.data.label"
        :lang="lang"
        :style="setActiveStyle"
        class="menuName" />
      <button v-if="item.children && item.children.length" type="button" :class="{openChildren: true, open: state.open}" @click="openChildren">
        <span class="left" :style="{backgroundColor: isActive ? colors.activeMenuText : colors.menuText}"></span>
        <span class="right" :style="{backgroundColor: isActive ? colors.activeMenuText : colors.menuText}"></span>
        <span class="blind">open</span>
      </button>
      <div v-if="item.isRoot && isActive" class="activeAcc bottom" :style="{background: activeAcc('bottom')}"></div>
    </div>
    <div v-show="item.children && item.children.length && state.open" class="list">
      <MenuItem
        v-for="item in item.children"
        :key="item.id"
        :lang="lang"
        :item="item"
        :responsive="responsive"
        :getActiveMenuId="getActiveMenuId"
        :getActiveMenuParentsIds="getActiveMenuParentsIds" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SetLink from '@/components/Util/SetLink.vue'

export default {
  name: 'MenuItem',
  props: [
    'lang',
    'item',
    'responsive',
    'getActiveMenuId',
    'getActiveMenuParentsIds'
  ],
  components: {
    SetLink
  },
  computed: {
    ...mapGetters({
      link: 'util/setLink'
    }),
    colors () {
      const setting = this.$store.getters['common/getSetting']
      return {
        ...setting.colors,
        activeMenuBg: (setting.responsive && setting.responsive.tablet && setting.responsive.tablet.colors.activeMenuBg) || setting.colors.activeMenuBg || setting.colors.menuText,
        activeMenuText: (setting.responsive && setting.responsive.tablet && setting.responsive.tablet.colors.activeMenuText) || setting.colors.activeMenuText || setting.colors.menuBg
      }
    },
    setActiveStyle () {
      const isDepth1 = this.item.isRoot
      const colors = this.colors
      return this.isActive && {
        color: colors.activeMenuText || '#333333',
        backgroundColor: colors.activeMenuBg || '#ffffff'
      }
    },
    isActive () {
      const isTablet = this.responsive === 'tablet'
      const isActive =  this.getActiveMenuId === this.item.data.id
      const isActiveParent = this.getActiveMenuParentsIds.includes(this.item.data.id)
      const isShop = this.$route.name === 'shop' && this.item.data.type === 'shop'
      const isRouterActive = (this.$route.params.shopPageId === this.item.data.shopPageId)
        && this.item.data.shopCategoryId
          ? this.currentShopCategory && this.currentShopCategory.includes(this.item.data.shopCategoryId)
          : true
      return isShop
        ? isRouterActive
        : isTablet && (isActive || isActiveParent)
    },
    hasIcon () {
      const onMobile = this.responsive === 'mobile' && this.item.data.icon && this.item.data.icon !== ''
      const onTablet = this.responsive === 'tablet' && this.item.data.icon2 && this.item.data.icon2 !== ''
      return onMobile || onTablet
    },
    activeMenuId () {
      return this.$store.state.routerActive
    },
    activeMenuParentIds () {
      return this.$store.state.routerActiveParents
    },
    currentShopCategory () {
      const shopPageId = this.$route.params.shopPageId
      const shopCategoryId = this.$route.params.shopCategoryId
      const shopCategory = shopPageId && this.$store.getters['shop/getCategoryProperty'](shopPageId)
      const currentCategory = shopCategory && findKeyByValue(shopCategory, shopCategoryId)
      function findKeyByValue(data, target) {
        for (const key in data) {
          if (data[key].includes(target)) {
            return data[key]
          }
        }
        return null // 없을 경우
      }
      return currentCategory
    }
  },
  data () {
    return {
      state: {
        open: false
      }
    }
  },
  methods: {
    setLink (target) {
      return this.link(target)
    },
    openChildren () {
      this.state.open = !this.state.open
    },
    activeAcc (pos) {
      const color = this.colors.activeMenuBg || this.colors.menuText
      return `radial-gradient(circle 12px at ${pos} left ,#0000 96%,${color}) ${pos} left`;
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
  .disabledTablet {
    display: none;
  }
}
@media screen and (max-width: 767px) {
  .disabledMobile {
    display: none;
  }
}
</style>
